import { useCallback, useEffect, useMemo, useRef } from 'react'

import SubscriptionEntryPoints from 'Pods/Shared/Constants/subscriptionEntryPoints'
import SubscriptionEvents from 'Pods/Shared/Constants/subscriptionEvents'
import useTracker from 'Pods/Shared/Hooks/useTracker'
import { setSubscriptionEntry } from 'Pods/Shared/Utils/subscriptionEntry'

const PAGE_TYPE = 'listing_page'

function useUpsellBlockTracking({ rendered = false, searchTerm = '', suggestedKeywords = '' }) {
  const { trackEvent } = useTracker()
  const trackedSearchRef = useRef(null)
  const searchKey = `${searchTerm}|${suggestedKeywords}`

  const eventData = useMemo(() => ({
    page_type: PAGE_TYPE,
    search_term: searchTerm,
    suggested_keywords: suggestedKeywords,
    free_filter_active: true,
  }), [searchTerm, suggestedKeywords])

  // The impression is the eligible-search denominator, so it counts renders of the real block -
  // `rendered` is false for the skeleton and for ineligible users. One per search, since keywords
  // and suggestion tags can change without the block unmounting.
  useEffect(() => {
    if (!rendered || trackedSearchRef.current === searchKey) return

    trackedSearchRef.current = searchKey
    trackEvent(SubscriptionEvents.UPSELL_BLOCK_IMPRESSION, eventData)
  }, [rendered, searchKey, eventData, trackEvent])

  const trackCtaClick = useCallback(() => {
    // Written first and synchronously, so the attribution survives even if the event itself is
    // lost as the page unloads. The anchor navigates natively.
    setSubscriptionEntry(SubscriptionEntryPoints.LISTING_FREE_FILTER_UPSELL)

    trackEvent(SubscriptionEvents.UPSELL_BLOCK_CTA_CLICK, eventData)
  }, [trackEvent, eventData])

  const trackCardClick = useCallback(({ itemId, index }) => {
    trackEvent(SubscriptionEvents.UPSELL_BLOCK_CARD_CLICK, {
      ...eventData,
      item_id: itemId,
      index,
    })
  }, [trackEvent, eventData])

  return { trackCtaClick, trackCardClick }
}

export default useUpsellBlockTracking
